type FormatAmountOptions = {
  value: number;
  buyersPremiumPercentage?: number;
  overheadPremiumPercentage?: number;
};

export function FormatAmount({
  value,
  buyersPremiumPercentage,
  overheadPremiumPercentage,
}: FormatAmountOptions) {
  let amountToFormat = value;

  if (buyersPremiumPercentage) {
    amountToFormat += value * (buyersPremiumPercentage / 100);
  }

  if (overheadPremiumPercentage) {
    amountToFormat += value * (overheadPremiumPercentage / 100);
  }

  return (
    <>
      {amountToFormat.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}{' '}
      USD
    </>
  );
}
